module.exports = __webpack_public_path__ + "img/12.a486a8ca.webp";